var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_547_997)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_547_997)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.5,
    cy: 920.5,
    rx: 163.5,
    ry: 101.5,
    fill: "#FF6600"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_547_997)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1236.5,
    cy: -13,
    rx: 210.5,
    ry: 107,
    fill: "#FF6600"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_547_997)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1964,
    cy: 8,
    rx: 219,
    ry: 245,
    fill: "#5ED9EC"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_547_997)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1565.5,
    cy: 1061.5,
    rx: 449.5,
    ry: 269.5,
    fill: "#8AD1FF",
    fillOpacity: 0.53
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_547_997)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 485,
    cy: -39.5,
    rx: 219,
    ry: 197.5,
    fill: "#A8CDE6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_547_997",
    x: -426,
    y: 393,
    width: 1179,
    height: 1055,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 213,
    result: "effect1_foregroundBlur_547_997"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_547_997",
    x: 600,
    y: -546,
    width: 1273,
    height: 1066,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 213,
    result: "effect1_foregroundBlur_547_997"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_547_997",
    x: 1271,
    y: -711,
    width: 1386,
    height: 1438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 237,
    result: "effect1_foregroundBlur_547_997"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_547_997",
    x: 642,
    y: 318,
    width: 1847,
    height: 1487,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 237,
    result: "effect1_foregroundBlur_547_997"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_547_997",
    x: -208,
    y: -711,
    width: 1386,
    height: 1343,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 237,
    result: "effect1_foregroundBlur_547_997"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_547_997"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.828e570d9a0772f38bb1d256ed50f9bc.svg";
export { ForwardRef as ReactComponent };